import { Product } from 'src/types/ViewModel/Stowage/Product/Product';
import { HighlightedText, ListItem, TradeInfoContainer, CategoryName, ChartererName } from './TradeNameSelectionListItem.style';
import React from 'react';

interface TradeNameSelectionListItemProps {
    product: Product;
    onClick?: (ev: any) => void;
    filterValue?: string;
    isSelected?: boolean;
}

const TradeNameSelectionListItem = ({ product, onClick, filterValue, isSelected }: TradeNameSelectionListItemProps) => {
    const highlightText = (text: string) => {
        if (!filterValue) return <span>{text}</span>;

        const parts = text.split(new RegExp(`(${filterValue})`, 'gi'));
        return (
            <span>
                {parts.map((part, index) =>
                    part.toLowerCase() === filterValue.toLowerCase() ? (
                        <HighlightedText key={index}>{part}</HighlightedText>
                    ) : (
                        <React.Fragment key={index}>{part}</React.Fragment>
                    )
                )}
            </span>
        );
    };

    return (
        <ListItem onClick={onClick} className={isSelected ? 'is-selected' : ''}>
            <TradeInfoContainer>
                {highlightText(product.tradeName)}
                <CategoryName>{highlightText(product.category.name)}</CategoryName>
            </TradeInfoContainer>
            <ChartererName>{highlightText(product.chartererName)}</ChartererName>
        </ListItem>
    );
};

export default TradeNameSelectionListItem;
